import React, { useCallback } from 'react';
import { useFormikContext } from 'formik';

import { useStore } from 'core/store/';
import { Discount } from '../discount';
import { track } from 'core/helpers/analytics';

const BixMutualAffinity = ({ isActive, ...discount }) => {
  const { setFieldValue, values } = useFormikContext();
  const { offer: store } = useStore();
  const isApplied = values.global ? values.global.discountBixMutualAffinity : isActive;
  const state = store.offer?.quote?.correctedAddress?.state;

  const onAddClick = useCallback(() => {
    setFieldValue('global.discountBixMutualAffinity', true);
    store.setIncludeBixMutualAffinity(true);
    track('BIX/Mutual Affinity Discount Added', {
      discount: discount.label,
      offerId: store.offer?.id,
      state
    });
  }, [setFieldValue, store, discount.label, state]);

  const onRemoveClick = useCallback(() => {
    setFieldValue('global.discountBixMutualAffinity', false);
    store.setIncludeBixMutualAffinity(false);
  }, [setFieldValue, store]);

  return <Discount {...discount} isActive={isApplied} onAdd={onAddClick} onRemove={onRemoveClick} />;
};

export default BixMutualAffinity;
